import React, { useEffect, useState } from "react";
import CustomTable from "../../components/customTable/CustomTable";
import RippleLoader from "../../components/loader/RippleLoader";
import DebounceSearch from "../../components/common/DebounceSearch";
import ReactSelect from "react-select";
import { SortDownArrow } from "../../assets/svg";
import { useNavigate } from "react-router-dom";
import Action from "../../components/common/Action";
import { AddButton, DefaultPrimaryButton } from "../../components/micro/input";
import Breadcrumb from "../../components/common/BreadCrumb";
import Toggles from "../../components/common/Toggles";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import {
  DeleteCompany,
  companiesList,
  updateCompany,
} from "../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";

const Companies = () => {
  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState("active");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [selectedType, setSelectedType] = useState(null);
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [companyIdToArchive, setCompanyIdToArchive] = useState(null);
  const [companyIdToUnarchive, setCompanyIdToUnarchive] = useState(null);
  const [confirmUnarchive, setConfirmUnarchive] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Selector
  const { companiesListData, loading } = useSelector((store) => ({
    companiesListData: store?.companiesData?.companiesListStatus?.data?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    dispatch(
      companiesList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        status: activeTab === "archived" ? "archive" : activeTab,
        contract: selectedType?.value,
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    activeTab,
    sortBy,
    sortDirection,
    selectedType,
  ]);

  const updateStatus = (element, status, isActive) => {
    dispatch(
      updateCompany({
        id: element?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateCompany/fulfilled") {
        dispatch(
          companiesList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            contract: selectedType?.value,
          })
        );
      }
    });
  };

  const handleToggle = (element) => {
    const newStatus = element.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(element, newStatus, isActive);
  };

  const handleArchive = () => {
    const companyToArchive = companiesListData?.data?.find(
      (company) => company.id === companyIdToArchive
    );

    if (companyToArchive) {
      updateStatus(companyToArchive, "archive", false);
    }
    setConfirmArchive(false);
  };

  const handleUnarchive = () => {
    const companyToUnarchive = companiesListData?.data?.find(
      (company) => company.id === companyIdToUnarchive
    );
    if (companyToUnarchive) {
      updateStatus(companyToUnarchive, "active", true);
    }
    setConfirmUnarchive(false);
  };

  const DeleteCompanyId = () => {
    setIsLoading(true);
    if (!companyIdToDelete) return;
    dispatch(DeleteCompany(companyIdToDelete)).then((res) => {
      if (res.type === "DeleteCompany/fulfilled") {
        dispatch(
          companiesList({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            status: activeTab === "archived" ? "archive" : activeTab,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
            contract: selectedType?.value,
          })
        );
      }
      setIsLoading(false);
      setConfirmDelete(false);
    });
  };

  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Company</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("outlets_count");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          No. Outlets
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "outlets_count"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("equipments_count  ");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          No. Equipment
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "equipments_count  "
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          Recurring
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      {activeTab === "active" && (
        <th
          scope="col"
          className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
        >
          <div className="flex items-center">
            <span>Status</span>
          </div>
        </th>
      )}
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Action
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(companiesListData?.data || [])?.map((element, index) => (
        <tr
          key={index}
          className="text-gray-500 text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange font-Proxima"
        >
          <td className="px-5 py-3 ">{element?.id}</td>
          <td className="px-5 py-3">
            {element?.name
              ? element?.name
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
              : "-"}
          </td>
          <td className="px-5 py-3">{element?.outlets_count}</td>
          <td className="px-5 py-3">{element?.equipments_count}</td>
          <td className="px-5 py-3">{element?.recurring || "-"}</td>
          {activeTab === "active" && (
            <td className="px-4 py-3 truncate">
              <Toggles
                checked={element?.status === "active"}
                toggleFor={element?.id}
                onChange={() => handleToggle(element)}
              />
            </td>
          )}
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      sessionStorage.setItem(
                        "companyData",
                        JSON.stringify({
                          company: element,
                        })
                      );

                      navigate("/company-information", {
                        state: { company: element, mode: "edit" },
                      });
                    }}
                  >
                    View/Edit
                  </li>
                  {activeTab === "active" ? (
                    <>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setConfirmArchive(true);
                          setCompanyIdToArchive(element?.id);
                        }}
                      >
                        Archive
                      </li>
                    </>
                  ) : (
                    <>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setCompanyIdToUnarchive(element?.id);
                          setConfirmUnarchive(true);
                        }}
                      >
                        Unarchive
                      </li>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => {
                          setConfirmDelete(true);
                          setCompanyIdToDelete(element?.id);
                        }}
                      >
                        Delete
                      </li>
                    </>
                  )}
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  const options = [
    { value: "recurring", label: "Recurring" },
    { value: "not_recurring", label: "Not on Recurring" },
    { value: "all", label: "All" },
  ];

  const handleExportClick = () => {
    if (!companiesListData?.data || companiesListData?.data.length === 0) {
      alert("No data available to export!");
      return;
    }

    const header = [
      "Company Name",
      "Outlets Count",
      "Equipments Count",
      "Recurring",
      "Status",
    ];

    const rows = companiesListData?.data.map((company) => [
      company.name,
      company.outlets_count,
      company.equipments_count,
      company.recurring || "-",
      company.status === "active" ? "Active" : "Inactive",
    ]);

    let csvContent = header.join(",") + "\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "companies_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <div className="space-y-5">
        <div className="flex justify-between items-start">
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Company & Outlets
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Company & Outlets"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
          <AddButton
            value="add Company"
            onClick={() =>
              navigate("/create-edit-company", {
                state: { company: companiesListData?.data, mode: "create" },
              })
            }
          />
        </div>
        <div className="flex justify-end">
          {["active", "archived"].map((tab, index) => (
            <button
              key={tab}
              className={`transition font-Proxima uppercase duration-300 text-sm font-normal px-4 py-1.5
        ${index === 0 ? "!rounded-l !rounded-r-none" : ""}
        ${index === 1 ? "!rounded-r !rounded-l-none" : ""}
        ${
          activeTab === tab
            ? "bg-themeBtn text-white shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
            : "bg-disabletheme text-white shadow-[0_4px_6px_rgba(0,0,0,0.2)]"
        }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="flex items-center space-x-3">
          <ReactSelect
            className={"w-full max-w-52 text-black p-0 font-Proxima"}
            id="role"
            placeholder={activeTab === "active" ? "All" : "Recurring"}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedType}
            onChange={(e) => {
              setSelectedType(e);
            }}
            options={options}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
          <div>
            <DefaultPrimaryButton
              value="EXPORT"
              height={"42px"}
              onClick={handleExportClick}
            />
          </div>
        </div>
        {loading ? (
          <RippleLoader />
        ) : (
          <div className="w-full bg-white shadow rounded-lg">
            <CustomTable
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={companiesListData}
              overflowVisibleLg={true}
              // loader
              loading={false}
              showPagination={true}
              // showLimit
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              // paginationData
              total={companiesListData?.total}
              lastPage={Math.ceil(companiesListData?.total / pageLimit)}
              current={pageCount}
              paginationData={(crPage) => setPageCount(crPage)}
            />
          </div>
        )}
      </div>
      {confirmArchive && (
        <div>
          <ConfirmationModel
            confirmText={"Archive"}
            onClose={() => {
              setConfirmArchive(false);
            }}
            onConfirm={handleArchive}
          />
        </div>
      )}
      {confirmUnarchive && (
        <div>
          <ConfirmationModel
            confirmText={"Unarchive"}
            onClose={() => {
              setConfirmUnarchive(false);
            }}
            onConfirm={handleUnarchive}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={DeleteCompanyId}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default Companies;
